import { render, staticRenderFns } from "./BackgroundModal.vue?vue&type=template&id=5a094ade&scoped=true"
import script from "./BackgroundModal.vue?vue&type=script&lang=js"
export * from "./BackgroundModal.vue?vue&type=script&lang=js"
import style0 from "./BackgroundModal.vue?vue&type=style&index=0&id=5a094ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a094ade",
  null
  
)

export default component.exports